import type { I_Announcement } from '../interfaces'
import { AnnouncementInnerViewItem, normalizeAnnouncementItem, ListNames } from '../config/configuration'
import { rhybusRListsHttp } from '../api/rhybus-list-http'
import { loadBlobFilesForItem } from './detailview'

export const getAnnouncementData = async (): Promise<AnnouncementInnerViewItem[]> => {
  try {
    const list = await rhybusRListsHttp().getList(ListNames.ANNOUNCEMENT)
    const items = [...(await list.query().orderBy([{ orderBy: 'ItemModified', ascending: false }]).get<I_Announcement>())]
    const filteredItems = (items ?? []).filter((item: I_Announcement) => !item.IsDeleted && item.IsArchived === false)
    const mapped = filteredItems.map((item) => normalizeAnnouncementItem(item as AnnouncementInnerViewItem))
    await Promise.all(mapped.map(async (item: any) => {
      if (!item.eKey) return
      const files = await loadBlobFilesForItem(item.eKey, 'announcements', 'announcements')
      if (files.length > 0) item.AttachmentFiles = files
    }))
    return mapped
  } catch (error) {
    console.error('Failed to fetch announcements:', error)
    return []
  }
}

export const announcementItems = await getAnnouncementData().then((data) =>
  data.map((item) => ({
    ID: item.ID,
    Title: item.Title,
    Description: item.Description,
    Tags: item.Tags,
    AttachmentFiles: item.AttachmentFiles,
    ItemModified: item.ItemModified ?? item.ExpiryDate,
    ItemModifiedBy: {
      Title: item.ItemModifiedBy?.Title ?? 'System'
    }
  }))
)
